import type { Integration } from "@/mocks/configuracoes";
import SettingsStatusBadge from "./SettingsStatusBadge";

interface IntegrationsGridProps {
  integrations: Integration[];
}

export default function IntegrationsGrid({ integrations }: IntegrationsGridProps) {
  return (
    <div className="space-y-4">
      <div className="bg-secondary-50 border border-secondary-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
            <i className="ri-information-line text-secondary-600 text-lg" />
          </div>
          <p className="text-xs text-secondary-700 leading-relaxed">
            As integrações permitem conectar o FloraIQ a serviços externos. As configurações reais serão implementadas
            com backend Python. Este painel é uma simulação visual da arquitetura planejada.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {integrations.map((int) => (
          <div key={int.id} className="bg-white rounded-xl border border-background-200/70 p-5 hover:border-background-300/60 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className={`${int.icon} text-accent-600 text-lg`} />
              </div>
              <SettingsStatusBadge status={int.status} />
            </div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-1">{int.name}</h4>
            <p className="text-xs text-foreground-500 mb-3">{int.description}</p>
            {int.lastSync && (
              <p className="text-xs text-foreground-400 mb-3">
                <i className="ri-refresh-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Última sincronização: {int.lastSync}
              </p>
            )}
            <button className={`w-full px-3 py-2 text-xs font-semibold rounded-lg transition-colors whitespace-nowrap ${
              int.status === "ativo" || int.status === "configurado"
                ? "text-primary-700 bg-primary-50 hover:bg-primary-100"
                : int.status === "planejado"
                ? "text-secondary-700 bg-secondary-50 hover:bg-secondary-100"
                : "text-foreground-500 bg-foreground-50 hover:bg-foreground-100"
            }`}>
              <i className="ri-settings-3-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
              Configurar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}